var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconToggle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 37 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fi-icon-toggle-base",
    x: 0.5,
    y: 3.5,
    width: 36,
    height: 13,
    rx: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fi-icon-toggle-knob",
    cx: 27,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "fi-icon-toggle-checkmark",
    d: "M31.724 7.692L26 13.71a.91.91 0 01-1.333 0l-2.391-2.512a1.03 1.03 0 010-1.403.911.911 0 011.333 0l1.724 1.813 5.057-5.316a.91.91 0 011.334 0 1.026 1.026 0 010 1.401"
  }))));
}

export default SvgIconToggle;